import { useDocumentMeta } from "../../hooks/useDocumentMeta";
type PageMetaProps = {
  title: string;
  description: string;
};
export function PageMeta({
  title,
  description
}: PageMetaProps) {
  useDocumentMeta(title, description);
  return null;
}